import { isEmpty } from "lodash";
export const ApiService = {};

ApiService.getRequest = (url = "", headers = {}) => {
  return new Promise((resolve, reject) => {
    let authCode = localStorage.getItem("bearer");
    fetch(url, {
      method: "GET", // or 'PUT'
      headers: {
        "Content-Type": "application/json",
        Authorization: authCode,
        "X-Auth-Token": "otk_ODMwYmI5OTUtNTg0Ni00NTMxLWE3YTMtZTE2ZWNmOWIxNmJh",
        Accept: "application/json",
        ...headers, // Spread any additional headers passed in
      },
    })
      .then((resp) => {
        jsonResponseIsValid(resp)
          .then((jsonData) => {
            const auth = resp.headers.get("Authorization");
            if (!isEmpty(auth)) {
              localStorage.setItem("bearer", auth);
            }

            return resolve(jsonData); // Assuming 'resolve' is defined somewhere
          })
          .catch((err) => reject(err));
      })
      .catch((err) => reject(err));
  });
};

ApiService.postRequest = (url = "", payload = null, extraHeaders = {}) => {
  return new Promise((resolve, reject) => {
    let authCode = localStorage.getItem("bearer");
    fetch(url, {
      method: "POST",
      body: payload ? JSON.stringify(payload) : "",
      headers: {
        "Content-Type": "application/json",
        Authorization: authCode,
        "X-Auth-Token": "otk_ODMwYmI5OTUtNTg0Ni00NTMxLWE3YTMtZTE2ZWNmOWIxNmJh",
        Accept: "application/json",
        ...extraHeaders,
      },
    })
      .then((resp) => {
        if (resp.status === 504) {
          if (authCode) localStorage.setItem("bearer", authCode);
          return resolve(resp);
        }

        const auth = resp.headers.get("Authorization");
        if (!isEmpty(auth)) {
          localStorage.setItem("bearer", auth);
        }
        return resolve(resp.json());
      })
      .catch((err) => reject(err));
  });
};

ApiService.postRequestWithLoginToken = (url = "", payload = null) => {
  return new Promise((resolve, reject) => {
    let authCode = localStorage.getItem("bearerProgressPercentage");
    fetch(url, {
      method: "POST",
      body: payload ? JSON.stringify(payload) : "",
      headers: {
        "Content-Type": "application/json",
        Authorization: authCode,
        "X-Auth-Token": "otk_ODMwYmI5OTUtNTg0Ni00NTMxLWE3YTMtZTE2ZWNmOWIxNmJh",
        Accept: "application/json",
      },
    })
      .then((resp) => {
        if (resp.status === 504) {
          if (authCode) localStorage.setItem("bearerProgressPercentage", authCode);
          if (authCode) localStorage.setItem("bearer", authCode);
          return resolve(resp);
        }

        const auth = resp.headers.get("Authorization");
        if (auth && auth.length > 0) {
          localStorage.setItem("bearerProgressPercentage", auth);
        }
        return resolve(resp.json());
      })
      .catch((err) => {
        reject(err);
      });
  });
};

ApiService.putRequest = (url = "", payload = null) => {
  return new Promise((resolve, reject) => {
    let authCode = localStorage.getItem("bearer");
    fetch(url, {
      method: "PUT",
      body: payload ? JSON.stringify(payload) : "",
      headers: {
        "Content-Type": "application/json",
        Authorization: authCode,
        "X-Auth-Token": "otk_ODMwYmI5OTUtNTg0Ni00NTMxLWE3YTMtZTE2ZWNmOWIxNmJh",
        Accept: "application/json",
      },
    })
      .then((resp) => {
        const auth = resp.headers.get("Authorization");
        if (!isEmpty(auth)) {
          localStorage.setItem("bearer", auth);
        }
        return resolve(resp.json());
      })
      .catch((err) => reject(err));
  });
};

ApiService.deleteRequest = (url = "", payload = null, extraHeaders = {}) => {
  return new Promise((resolve, reject) => {
    let authCode = localStorage.getItem("bearer");
    fetch(url, {
      method: "Delete",
      body: payload ? JSON.stringify(payload) : "",
      headers: {
        "Content-Type": "application/json",
        Authorization: authCode,
        "X-Auth-Token": "otk_ODMwYmI5OTUtNTg0Ni00NTMxLWE3YTMtZTE2ZWNmOWIxNmJh",
        Accept: "application/json",
        ...extraHeaders, // Spread any additional headers passed in
      },
    })
      .then((resp) => {
        const auth = resp.headers.get("Authorization");
        if (!isEmpty(auth)) {
          localStorage.setItem("bearer", auth);
        }
        return resolve(resp.json());
      })
      .catch((err) => reject(err));
  });
};

ApiService.getRequestWithoutAuth = (url = "") => {
  return new Promise((resolve, reject) => {
    fetch(url, {
      method: "GET", // or 'PUT'
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    })
      .then((resp) => {
        jsonResponseIsValid(resp)
          .then((jsonData) => {
            return resolve(jsonData);
          })
          .catch((err) => reject(err));
      })
      .catch((err) => reject(err));
  });
};

ApiService.postRequestWithoutAuth = (url = "", payload = null) => {
  return new Promise((resolve, reject) => {
    fetch(url, {
      method: "POST",
      body: payload ? JSON.stringify(payload) : "",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    })
      .then((resp) => {
        return resolve(resp.json());
      })
      .catch((err) => reject(err));
  });
};

ApiService.deleteRequestWithXAuth = (url = "", payload = null) => {
  return new Promise((resolve, reject) => {
    let authCode = localStorage.getItem("bearer");
    let xAuth = localStorage.getItem("x-auth-token");
    fetch(url, {
      method: "Delete",
      body: payload ? JSON.stringify(payload) : "",
      headers: {
        "Content-Type": "application/json",
        Authorization: authCode,
        "X-Auth-Token": xAuth,
        Accept: "application/json",
      },
    })
      .then((resp) => {
        return resolve(resp.json());
      })
      .catch((err) => reject(err));
  });
};

const jsonResponseIsValid = (resp) => {
  return new Promise((resolve, reject) => {
    resp
      .json()
      .then((jsonData) => {
        resolve(jsonData);
      })
      .catch((err) => {
        reject(err); // Handle potential errors in fetching JSON
      });
  });
};
